import { c as _c } from "react/compiler-runtime";
import zip from 'lodash/zip';
import useStore from './use-store';
const useEdgeContext = (sourceId, targetId) => {
  const $ = _c(3);
  const {
    data: t0
  } = useStore();
  const {
    nodeHighlight,
    traceEntries
  } = t0;
  const highlightThisEdge = nodeHighlight?.ids.includes(sourceId) && nodeHighlight?.ids.includes(targetId);
  let t1;
  bb0: {
    if (nodeHighlight && highlightThisEdge) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          error: "var(--border-color-error)",
          info: "var(--border-color-info)"
        };
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2[nodeHighlight.color];
      break bb0;
    }
    const isEdgeAlongExecutionTrace = zip(traceEntries, traceEntries?.slice(1)).some(t2 => {
      const [source, target] = t2;
      return source?.decisionNodeId === sourceId && target?.decisionNodeId === targetId;
    });
    if (isEdgeAlongExecutionTrace) {
      t1 = "var(--border-color-accent)";
      break bb0;
    }
    t1 = undefined;
  }
  const edgeColorStroke = t1;
  let t2;
  if ($[1] !== edgeColorStroke) {
    t2 = {
      edgeColorStroke
    };
    $[1] = edgeColorStroke;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default useEdgeContext;